<template>
  <basic-container>
    <div class="page">
      <h1
        style="background-color: #fff; font-family: fangSong;font-weight: bold;"
      >
        添加员工档案信息
      </h1>
      <div
        class="page-description"
        v-for="(group, groupIndex) in result"
        :key="groupIndex"
      >
        <el-form v-if="group.manageShow == 'true'" class="form-group">
          <el-row v-if="group.manageShow == 'true'">
            <el-col :span="24">
              <div class="group-title">
                {{ group.group_name }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="group.manageShow == 'true'">
            <el-col
              v-for="(field, fieldIndex) in group.field_meta_info_list"
              :key="fieldIndex"
              :span="12"
            >
              <div v-if="field.fieldType != 'NONE'" class="field-text">
                {{ field.field_name }}
              </div>
              <!-- 处理不同字段类型 -->
              <template v-if="field.fieldType === 'NONE'"></template>
              <template v-if="field.fieldType === 'TextField'">
                <el-input
                  clearable
                  type="text"
                  v-model="result[groupIndex][field.id]"
                  placeholder="请输入"
                  @input="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                  class="field-input"
                />
              </template>
              <template v-else-if="field.fieldType === 'DDSelectField'">
                <el-select
                  clearable
                  v-model="result[groupIndex][field.id]"
                  placeholder="请选择"
                  @change="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                >
                  <el-option
                    v-for="(item, index) in JSON.parse(field.option_text)"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <!-- 部门el-Cascader级联选择器 -->
              <template v-else-if="field.fieldType === 'DDTreeField'">
                <el-cascader
                  clearable
                  v-model="result[groupIndex][field.id]"
                  :options="JSON.parse(field.option_text)"
                  placeholder="请选择"
                  change-on-select
                  filterable
                  @change="
                    handleTreeChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                ></el-cascader>
              </template>
              <template
                v-else-if="
                  field.fieldType === 'DDDateField' ||
                    field.fieldType === 'DDDateWithLongField'
                "
              >
                <el-date-picker
                  clearable
                  v-if="field.fieldType === 'DDDateField'"
                  v-model="result[groupIndex][field.id]"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  @change="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                ></el-date-picker>
                <el-date-picker
                  clearable
                  v-else-if="field.fieldType === 'DDDateWithLongField'"
                  v-model="result[groupIndex][field.id]"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                ></el-date-picker>
              </template>
              <template v-else-if="field.fieldType === 'DDPhotoField'">
                <div class="uploadPicture">
                  <!-- 表单的图片上传到阿里云服务器,限制1张 -->
                  <el-upload
                    class="upload-demo"
                    action="#"
                    accept="image/jpeg,image/jpg,image/png"
                    :http-request="uploadFile(groupIndex, field.id)"
                    :show-file-list="false"
                  >
                    <i v-if="!field.value" class="el-icon-plus"></i>
                    <!-- 上传成功后回显 -->
                    <img
                      v-else
                      :src="field.value"
                      class="avatar"
                      style="width: 100px; height: 100px;"
                    />
                  </el-upload>
                  <!-- 否则为删除 -->
                  <i
                    v-if="field.value"
                    class="el-icon-delete delIcon"
                    @click="
                      handleDelChange(
                        groupIndex,
                        field.id,
                        result[groupIndex][field.id]
                      )
                    "
                  ></i>
                </div>
              </template>
            </el-col>
          </el-row>
          <el-row style="text-align: center;">
            <el-button
              v-if="group.detail == 'true'"
              @click="addFieldToGroup(groupIndex)"
              class="add-button"
            >
              增加明细
            </el-button>
            <el-button
              v-if="group.delShow == 'true'"
              @click="delFieldToGroup(groupIndex)"
              class="add-button"
            >
              删除明细
            </el-button>
          </el-row>
        </el-form>
      </div>
      <div class="footer-box">
        <el-button class="submit-button" type="primary" @click="submitForm"
          >提交</el-button
        >
      </div>
    </div>
  </basic-container>
</template>

<script>
import { findRosterField, addRoster } from "@/api/salesCloud/stuff";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import { resolveUrlPath } from "@/util/util";
import oss from "ali-oss";
import md5 from "js-md5";
export default {
  data() {
    return {
      result: [],
    };
  },
  created() {
    this.getRosterField();
  },
  methods: {
    /**
     * 上传文件到阿里云服务器
     */
    uploadFile(groupIndex, fieldId) {
      return (option) => {
        // 上传文件到阿里云服务器
        getAliyunPublicToken().then((res) => {
          let data = JSON.parse(res.data);
          const client = new oss({
            region: data.point,
            endPoint: data.point,
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            Expiration: data.expiration,
            bucket: data.bucketName,
            stsToken: data.securityToken,
          });
          const storeAs = md5(option.file.name) + new Date().getTime();

          // 查找对应的 field_meta_info_list 对象
          const fieldMetaInfo = this.result[
            groupIndex
          ].field_meta_info_list.find((field) => field.id === fieldId);
          if (!fieldMetaInfo) {
            return;
          }

          if (!fieldMetaInfo.value) {
            // 如果 value 不存在，初始化为一个空字符串
            fieldMetaInfo.value = "";
          }
          client
            .multipartUpload(storeAs, option.file, {})
            .then((results) => {
              let res = results.res.requestUrls[0].split("?");
              const imageURL = res[0];

              if (fieldMetaInfo.value) {
                // 如果 value 已经有值，表示这是多图情况
                fieldMetaInfo.value += "," + imageURL;
              } else {
                // 如果 value 为空，表示这是单图情况
                fieldMetaInfo.value = imageURL;
              }
              console.log(fieldMetaInfo.value, "fieldMetaInfo.value");
              // 添加到 field_meta_info_list[].value 数组中
              this.result[groupIndex][fieldId] = fieldMetaInfo.value;
              // 更新 fileList 以便显示上传的文件
              this.updateFileList();
            })
            .catch((err) => {
              console.error(err);
            });
        });
      };
    },
    updateFileList() {
      // 清空 fileList
      this.fileList = [];

      this.result.forEach((group) => {
        group.field_meta_info_list.forEach((field) => {
          if (field.fieldType === "DDPhotoField") {
            // 如果是图片上传控件
            if (field.value) {
              // 如果有图片 URL，拆分成数组并更新 fileList
              const imageURLs = field.value.split(",");
              imageURLs.forEach((url, index) => {
                this.fileList.push({
                  name: `Image ${index + 1}`,
                  url: url,
                });
              });
            }
          }
        });
      });
    },
    // 获取员工档案字段
    getRosterField() {
      findRosterField().then((res) => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          data.forEach((item) => {
            item.field_meta_info_list.forEach((field) => {
              if (field.fieldType === "DDTreeField") {
                // 如果存在 option_text，进行修改
                if (field.option_text) {
                  var options = JSON.parse(field.option_text);
                  // 递归修改树形结构内的数据
                  options = this.changeTreeData(options);

                  field.option_text = JSON.stringify(options);
                }
              }
            });
          });
          this.result = data;
        }
      });
    },

    // 递归修改树形结构内的数据
    changeTreeData(data) {
      data.forEach((item) => {
        item.value = item.id;
        item.label = item.name;
        if (item.children.length == 0) {
          delete item.children;
        }
        delete item.id;
        delete item.name;
        if (item.children && item.children.length > 0) {
          this.changeTreeData(item.children);
        }
      });
      return data;
    },
    // 部门el-Cascader级联选择器，可单选选择任意一级菜单的选项
    handleTreeChange(groupIndex, fieldId, selectedValue) {
      // 处理用户选择，你可以在这里进行其他逻辑
      console.log(groupIndex, fieldId, selectedValue);
      // 将选择的值赋给对应的层级
      this.result[groupIndex][fieldId] = selectedValue;
    },
    // 处理用户输入
    handleInputChange(groupIndex, fieldCode, value) {
      console.log(groupIndex, fieldCode, value);
      // 处理用户输入，可以进行验证或其他逻辑
      this.result[groupIndex][fieldCode] = value;
    },
    handleDelChange(groupIndex, fieldId, value) {
      console.log(groupIndex, fieldId, value);
      // 获取要删除的字段组
      const group = this.result[groupIndex];

      // 查找对应的 field_meta_info_list 对象
      const fieldMetaInfo = group.field_meta_info_list.find(
        (field) => field.id === fieldId
      );

      if (fieldMetaInfo) {
        // 将 value 置为空，表示没有图片
        fieldMetaInfo.value = "";

        // 清空结果中对应字段的值
        this.result[groupIndex][fieldId] = "";

        // 使用Vue.set来更新数据以触发Vue的数据检测
        this.$set(group, fieldId, this.result[groupIndex][fieldId]);

        // 更新文件列表以便显示上传的文件
        this.updateFileList();
      }
    },

    // 添加明细
    addFieldToGroup(groupIndex) {
      // 点击的这个字段组的detail设置为false
      this.result[groupIndex].detail = "false";
      //新增一个是可新增明细的属性给字段组
      this.result[groupIndex].detailShow = "true";
      // 创建一个新字段组
      const newGroup = JSON.parse(JSON.stringify(this.result[groupIndex]));
      //新增一个是可删除当前明细的属性给字段组
      newGroup.delShow = "true";
      // 新增一个代表这个字段组是可删除的
      newGroup.Del = "true";
      // 将新的detail设置为true
      newGroup.detail = "true";

      // 递增字段组名称中的索引
      newGroup.group_name = this.getGroupNameWithIndex(newGroup.group_name);

      // 清空新字段组中的数据
      for (const field of newGroup.field_meta_info_list) {
        field.value = null;
      }

      // 添加新字段组到选择的字段组之后
      this.result.splice(groupIndex + 1, 0, newGroup);
    },
    // 删除明细
    delFieldToGroup(groupIndex) {
      if (this.result[groupIndex].Del == "true") {
        // 删除当前明细
        this.result.splice(groupIndex, 1);
        // 点击的这个字段组的detail设置为true
        this.result[groupIndex - 1].detail = "true";
        //新增一个是可新增明细的属性给字段组
        this.result[groupIndex - 1].detailShow = "true";
        //新增一个是可删除当前明细的属性给字段组
        this.result[groupIndex - 1].delShow = "true";
      } else {
        this.$message({
          message: "不可以删除啦！",
          type: "warning",
        });
      }
    },
    // 获取带有索引的字段组名称
    getGroupNameWithIndex(groupName) {
      // 从 groupName 中提取当前索引，如果没有索引则默认为 0
      const match = groupName.match(/(\d+)$/);
      let index = 1;
      if (match) {
        index = parseInt(match[1], 10) + 1;
      }

      // groupName只取前面的中文部分
      groupName = groupName.replace(/\d+$/, "");

      // 将递增的索引添加到 groupName 中
      return `${groupName}${index}`;
    },
    // 提交表单
    submitForm() {
      const validationPassed = this.validateFields(this.result);
      if (validationPassed) {
        const processedResult = {};
        const clonedResult = this.cloneResult(this.result);

        clonedResult.forEach((group) => {
          if (group.manageShow === "true") {
            group.field_meta_info_list.forEach((field) => {
              if (field.fieldType !== "NONE") {
                const { id } = field;
                const value = group[id];

                if (!processedResult[id]) {
                  processedResult[id] = { ...field, value };
                } else {
                  processedResult[id].value = processedResult[id].value
                    ? `${processedResult[id].value},${value}`
                    : value;
                }
              }
            });
          }
        });

        clonedResult.forEach((group) => {
          if (group.manageShow === "true") {
            group.field_meta_info_list.forEach((field) => {
              if (field.fieldType !== "NONE") {
                const { id } = field;
                if (processedResult[id]) {
                  field.value = processedResult[id].value;
                }
              }
              // 如果是级联选择器，将value转换为字符串并且只取最后一级的
              if (field.fieldType === "DDTreeField") {
                if (field.value && field.value.length > 0) {
                  field.value = field.value[field.value.length - 1].toString();
                } else {
                  field.value = null;
                }
              }
              //如果field.fieldType === 'DDDateWithLongField'，将value转换为字符串
              if (field.fieldType === "DDDateWithLongField") {
                if (field.value) {
                  field.value = field.value.toString();
                } else {
                  field.value = null;
                }
              }
            });
          }
          // 如果detailShow为true，将这个的detail设置为true
          if (group.detailShow) {
            group.detail = "true";
          }
        });

        const uniqueObjects = this.filterUniqueObjects(clonedResult);

        console.log(uniqueObjects);
        // 在这里添加提交数据到服务器的代码
        this.submitDataToServer(uniqueObjects);
      }
    },

    // 递归函数，遍历所有字段组并验证字段值
    validateFields(groups) {
      for (const group of groups) {
        if (group.detail === "true") {
          for (const field of group.field_meta_info_list) {
            if (field.fieldType !== "NONE") {
              const value = group[field.id];
              if (!value) {
                this.$message({
                  message: `请填写 ${field.field_name}`,
                  type: "warning",
                });
                return false; // 有字段值为空，验证不通过
              }
            }
          }
        }
        // 递归处理子字段组
        if (group.children && group.children.length > 0) {
          const childGroups = group.children.filter(
            (child) => child.manageShow === "true"
          );
          if (childGroups.length > 0) {
            const validationPassed = this.validateFields(childGroups);
            if (!validationPassed) {
              return false; // 有子字段组验证不通过
            }
          }
        }
      }
      return true; // 所有字段验证通过
    },
    // 提交数据到后台
    async submitDataToServer(data) {
      let item = {
        close: true,
        label: "新增员工",
        value: "/salesCloud/stuff/add"
      };
      // 提交数据到服务器addRoster
      console.log(data, "data");
      const res = await addRoster(data);
      if (res.code === "200") {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.$store.commit("DEL_TAG", item);
        this.$router.push({
          path: resolveUrlPath("/salesCloud/stuff"),
        });
      } else if (res.code === "40103") {
        this.$message({
          message: res.message?res.message:"添加成功",
          type: "success",
        });
        this.$store.commit("DEL_TAG", item);
        //关闭页面，返回上一级
        this.$router.push({
          path: resolveUrlPath("/salesCloud/stuff"),
        });
      }else {
        this.$message({
          message: res.message?res.message:"添加失败",
          type: "error",
        });
      }
    },

    // 克隆 result 数组
    cloneResult(result) {
      return JSON.parse(JSON.stringify(result));
    },
    // 过滤重复的对象
    filterUniqueObjects(clonedResult) {
      const uniqueIds = new Set();
      return clonedResult.filter((group) => {
        if (uniqueIds.has(group.id)) {
          return false;
        }
        uniqueIds.add(group.id);
        return true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: #f4f4f4; /* 背景色 */
  font-family: fangSong;
  font-weight: bold;
}
.uploadPicture {
  display: flex;
}
.delIcon {
  width: 100px;
  height: 100px;
  // border: 1px dashed #ccc;
  border-radius: 6px;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
}
.form-group {
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  .el-row {
    padding: 10px;
    .el-col-12 {
      padding: 0 10px;
    }
  }
}

.group-title {
  font-weight: bold;
  margin: 10px 0;
  color: #3569ff; /* 主色 */
}
.group-box {
  background-color: #fff;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
.field-text {
  margin-bottom: 5px;
}

.field-input {
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
}
::v-deep .uni-select {
  background-color: #fff;
}
::v-deep .uni-date-editor {
  height: 100px;
}
::v-deep .el-cascader {
  height: 38px;
}
.add-button {
  margin-top: 5px;
  background-color: #3569ff; /* 主色 */
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #2d5bd8; /* 鼠标悬停时的颜色 */
  }
}
.page-description {
  border-bottom: #f4f4f4 solid 1px;
}
.footer-box {
  padding: 20px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  .submit-button {
    background-color: #3569ff; /* 主色 */
    color: #fff;
    border: none;
    width: 100%;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      background-color: #2d5bd8; /* 鼠标悬停时的颜色 */
    }
  }
}
</style>
